import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useState, useEffect } from 'react';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from 'jquery';
import Select, { components } from "react-select";
import { useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Fixedshift(props) {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    // branch options
    const [brOptions, setBrOptions] = useState([]);
    const [branchId, setBranchId] = useState("");
    //focus
    const branchRef = useRef(null);
    const staffRef = useRef(null);
    const shiftRef = useRef(null);
    const toDateRef = useRef(null);
    const [toDateError, setToDateError] = useState("");
    // department options
    const [deptOptions, setDeptOptions] = useState([]);
    const [departmentId, setDepartmentId] = useState("");
    // staff options
    const [staffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [staffCode, setStaffCode] = useState("");
    const [shiftOptions, setShiftOptions] = useState([]);
    const [shiftType, setShiftType] = useState("");
   // const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    // get all branch name in the select dropdown
    const getbranch = () => {
        axios
            .get(baseurladdress + "getallbranchs", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
               // console.log(res.data.response);
                const options = res.data.response.map((item) => ({
                    value: item.branch_id,      
                    label: item.branch_name     
                }));
                setBrOptions(options);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    // get all department name in the select dropdown
    const getDepartments = () => {

        axios
            .get(baseurladdress + "getalldepts", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {

                console.log(res.data.response);
                const options = res.data.response.map(item => ({
                    value: item.dept_id,
                    label: item.dept_name,
                    code: item.dept_code
                }));
              
                setDeptOptions(options);

            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        getbranch();
        getDepartments();
    }, []);
    // get all staff name in the select dropdown based on selected branch and department
    const getStaff = async () => {

        try {

            let response;

            // Branch + Department selected
            if (branchId && departmentId) {

                response = await axios.get(
                    `${baseurladdress}getAllStaffBranchandDept/${branchId}/${departmentId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

            }
            // Only Branch selected
            else if (branchId) {

                response = await axios.get(
                    `${baseurladdress}getStaffByBranch/${branchId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

            }
            else {

                setStaffOptions([]);
                return;

            }

            const options = response.data.response.map((item) => ({
                value: item.staff_id,
                label: item.staff_name,
                code: item.staff_code
            }));

            setStaffOptions(options);

        } catch (err) {

            console.log(err);
            setStaffOptions([]);

        }
    };
   
    useEffect(() => {

        getStaff();

        setSelectedStaff([]);
        setStaffCode("");

    }, [branchId, departmentId]);
  
    const Option = (props) => {
        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: 8 }}
                />

                <span
                    style={{
                        color: props.data.value === "all" ? "#007bff" : "#000",
                        fontWeight: props.data.value === "all" ? "600" : "400"
                    }}
                >
                    {props.label}
                </span>
            </components.Option>
        );
    };
    // handle click 
    const handleStaffChange = (selected) => {

        if (!selected || selected.length === 0) {
            setSelectedStaff([]);
            setStaffCode("");
            return;
        }

        const hasAll = selected.some(item => item.value === "all");

        if (hasAll) {

            // Toggle All
            if (selectedStaff.length === staffOptions.length) {

                setSelectedStaff([]);
                setStaffCode("");

            } else {

                setSelectedStaff(staffOptions);

                const allCodes = staffOptions
                    .map(item => item.code)
                    .join(", ");

                setStaffCode(allCodes);
            }

            return;
        }

        // Individual selection
        setSelectedStaff(selected);

        const selectedCodes = selected
            .map(item => item.code)
            .join(", ");

        setStaffCode(selectedCodes);
    };   
    //get all shift type in the select dropdown
    const getShiftTypes = async () => {

        try {

            const response = await axios.get(
                `${baseurladdress}getallshifttype`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            console.log(response.data);

            const options = response.data.response.map((item) => ({
                value: item.type_id,
                label: item.type_name
            }));

            setShiftOptions(options);

        } catch (error) {

            console.log(error);

        }

    };
    useEffect(() => {

        getShiftTypes();

    }, []);
    // Add fixed shift assignment
    const saveShiftAssignment = async () => {

        try {

            if (!branchId) {
                branchRef.current?.focus();
                return;
            }
               
            if (selectedStaff.length === 0) {
              
                staffRef.current?.focus();
                return;
            }

            if (!shiftType) {
               
                shiftRef.current?.focus();
                return;
            }

            if (toDate && new Date(toDate) < new Date(fromDate)) {

                setToDateError("To Date cannot be earlier than From Date");
                toDateRef.current?.focus();
                return;
            } else {
                setToDateError("");
            }
            const shiftName = shiftOptions.find(
                x => x.value === shiftType
            )?.label;

            for (const staff of selectedStaff) {

                const payload = {

                    assign_staffid: staff.value,
                    assign_staffcode: staff.code,
                    assign_staffname: staff.label,

                    assign_branchid: branchId,
                    assign_branchname: brOptions.find(
                        x => x.value === branchId
                    )?.label,

                    assign_deptid: departmentId,
                    assign_deptname: deptOptions.find(
                        x => x.value === departmentId
                    )?.label,

                    assign_deptcode: deptOptions.find(
                        x => x.value === departmentId
                    )?.code,

                    assign_shifttypeid: shiftType,
                    asign_shiftname: shiftName,

                    assing_fromdate: fromDate,
                    assign_todate: toDate || null,

                    assign_updby: accessuserid
                };

                console.log(payload);

                const response = await axios.post(
                    `${baseurladdress}addshiftAssignment`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`
                        }
                    }
                );

                console.log(response.data);

                if (response.data.status === "error") {
                    alert(response.data.message);
                    return;
                }
            }
            toast.success("Shift Assigned Successfully");

            setBranchId("");
            setDepartmentId("");
            setSelectedStaff([]);
            setStaffCode("");
            setShiftType("");
            setFromDate("");
            setToDate("");

           

        } catch (err) {

            console.log(err);

            if (err.response) {
                console.log(err.response.data);
                alert(err.response.data.message);
            } else {
                alert(err.message);
            }

        }

    };    
    // Hide Previous Date
    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split("T")[0];
    };

    const [fromDate, setFromDate] = useState(getTomorrowDate());
    return (
        <div>
            <Topnavbar />
            <Sidennav />

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
            />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div class="card">
                                <div class="card-header" style={{ "color": "black" }}>
                                    <h6 class="card-title"> FIXED SHIFT DETAILS
                                    </h6>
                                 
                                </div>

                                <div class="card-body">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h6>Add Shift Assignment</h6>
                                                <div className="row">

                                                    <div className="col-md-3 mb-3">
                                                        <label>
                                                            <span className="text-danger">*</span> Branch
                                                        </label>
                                                        <Select
                                                            ref={branchRef}
                                                            options={brOptions}
                                                            value={brOptions.find(x => x.value === branchId) || null}
                                                            onChange={(selected) => {

                                                                setBranchId(selected ? selected.value : "");
                                                                setDepartmentId("");

                                                            }}
                                                        />

                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label>
                                                          Department
                                                        </label>
                                                        <Select
                                                            options={deptOptions}
                                                            value={deptOptions.find(x => x.value === departmentId) || null}
                                                            onChange={(selected) =>

                                                                setDepartmentId(selected ? selected.value : "")

                                                            }
                                                        />

                                                    </div>

                                                    <div className="col-md-3 mb-3">
                                                        <label>
                                                            <span className="text-danger">*</span> Staff Name
                                                        </label>
                                                        <Select
                                                            ref={staffRef}
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            options={[
                                                                { value: "all", label: "All" },
                                                                ...staffOptions
                                                            ]}
                                                            value={selectedStaff}
                                                            onChange={handleStaffChange}
                                                            components={{ Option }}
                                                            placeholder="Select Staff"
                                                        />


                                                    </div>

                                                    <div className="col-md-3 mb-3">
                                                        <label>Staff Code</label>

                                                        <input
                                                            className="form-control"
                                                            value={staffCode}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label>
                                                            <span className="text-danger">*</span> Shift Type
                                                        </label>

                                                        <Select
                                                            ref={shiftRef}
                                                            options={shiftOptions}
                                                            placeholder="Select Shift Type"
                                                            isClearable
                                                            value={
                                                                shiftOptions.find(
                                                                    option => option.value === shiftType
                                                                ) || null
                                                            }
                                                            onChange={(selected) =>
                                                                setShiftType(selected ? selected.value : "")
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label>From Date</label>

                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={fromDate}
                                                            min={getTomorrowDate()}
                                                            onChange={(e) => setFromDate(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <label>To Date</label>

                                                        <input
                                                            ref={toDateRef}
                                                            type="date"
                                                            className={`form-control ${toDateError ? "is-invalid" : ""}`}
                                                            value={toDate}
                                                            onChange={(e) => {
                                                                setToDate(e.target.value);
                                                                setToDateError("");
                                                            }}
                                                        />

                                                        {toDateError && (
                                                            <small className="text-danger">
                                                                {toDateError}
                                                            </small>
                                                        )}
                                                    </div>
                                                   

                                                    <div className="col-12 offset-5 mt-4 mb-4">

                                                     
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={saveShiftAssignment}
                                                        >
                                                            Save
                                                        </button>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Fixedshift;
